@if (visible) {
  <mat-progress-bar 
    color="primary" 
    [bufferValue]="bufferValue" 
    [mode]="mode" 
    [value]="value"
    [attr.aria-label]="mode === 'determinate' ? 'Progresso: ' + value + '%' : 'Carregando...'"
    [attr.aria-valuenow]="mode === 'determinate' ? value : null"
    [attr.aria-valuemin]="mode === 'determinate' ? 0 : null"
    [attr.aria-valuemax]="mode === 'determinate' ? 100 : null"
    role="progressbar">
  </mat-progress-bar>
  @if (mode === 'indeterminate') {
    <span class="sr-only" role="status" aria-live="polite">Carregando, aguarde...</span>
  }
}
